import { Box, Modal, TextField } from "@mui/material";
import React, { useState } from "react";
// import { RxCrossCircled } from "react-icons/rx";
// import SuccessBackground from "../../../../asesst/SuccessBackground.svg";
// import Tick from "../../../../asesst/tick.svg";
import { breadcrumbNameMap } from "../../../utils/helperData";
import Breadcrumbs from "../../../customComponent/BreadCrumbs";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { WELDING_MASTER } from "../../../utils/RouteConstant";
import { addWelderMaster } from "../../../../redux/action/Master/MasterAction";
import SuccessMasterModal from "../MasterTable/SuccessMasterModal";
import { toast } from "react-toastify";

const AddWeldingMaster = () => {
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOpenSaveModal = () => setOpenSaveModal(true);
  const handleCloseSaveModal = () => {
    setOpenSaveModal(false);
    navigate(WELDING_MASTER);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
  });

  const handleSave = async (values) => {
    try {
      await dispatch(addWelderMaster(values));
      handleOpenSaveModal();
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err.message || "An error occurred";
      toast.error(errorMessage);
    }
  };

  const handleCancel = () => {
    navigate(WELDING_MASTER);
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-bold mb-6">Weld Additional Info</h2>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <div>
          <h2 className="text-2xl font-base font-poppins mb-8 text-[#202224]">
            Add Weld Additional Info
          </h2>
        </div>
        <Formik
          initialValues={{ name: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSave}
        >
          {({ handleSubmit, handleChange, values, errors, touched }) => (
            <form onSubmit={handleSubmit}>
              <div>
                <h3 className="text-base font-base text-[#1C3664] mb-2">
                  Details
                </h3>
                <div
                  style={{ borderBottom: "3px solid #1C3664", width: "5%" }}
                ></div>
                <div className="space-y-4 md:space-y-6 pt-10">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    <TextField
                      label="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      fullWidth
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end space-x-4 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#1C3664] text-white rounded-md"
                >
                  Save Details
                </button>
              </div>
            </form>
          )}
        </Formik>
        <br />
      </div>

      {/* {openSaveModal && (
        <Modal open={openSaveModal} className="justify-center items-center ">
          <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
            <RxCrossCircled
              onClick={handleCloseSaveModal}
              className="float-end top-2 h-6 w-6 cursor-pointer"
            />
            <div className="text-center inline-flex mt-8">
              <div
                className="w-[72px] h-[72px] flex items-center justify-center"
                style={{ backgroundImage: `url(${SuccessBackground})` }}
              >
                <img src={Tick} alt="Success" className="w-7 h-7" />
              </div>
            </div>
            <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
              Success
            </p>
            <span className="text-[#6D6D6D]">
              New Welding Master added successfully
            </span>
            <div className="mt-6 flex justify-center gap-4">
              <button
                onClick={handleCloseSaveModal}
                className="border border-inherit px-4 py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          </Box>
        </Modal>
      )} */}
      <SuccessMasterModal
        open={openSaveModal}
        title="Success"
        message="New Welding Master added successfully"
        onClose={handleCloseSaveModal}
      />
    </div>
  );
};

export default AddWeldingMaster;
